// src/redux/schoolActionTypes.js
export const FETCH_SCHOOLS_REQUEST = 'FETCH_SCHOOLS_REQUEST';
export const FETCH_SCHOOLS_SUCCESS = 'FETCH_SCHOOLS_SUCCESS';
export const FETCH_SCHOOLS_FAILURE = 'FETCH_SCHOOLS_FAILURE';
export const ADD_SCHOOL_REQUEST = 'ADD_SCHOOL_REQUEST';
export const ADD_SCHOOL_SUCCESS = 'ADD_SCHOOL_SUCCESS';
export const ADD_SCHOOL_FAILURE = 'ADD_SCHOOL_FAILURE';
export const UPDATE_SCHOOL_REQUEST = 'UPDATE_SCHOOL_REQUEST';
export const UPDATE_SCHOOL_SUCCESS = 'UPDATE_SCHOOL_SUCCESS';
export const UPDATE_SCHOOL_FAILURE = 'UPDATE_SCHOOL_FAILURE';
export const DELETE_SCHOOL_REQUEST = 'DELETE_SCHOOL_REQUEST';
export const DELETE_SCHOOL_SUCCESS = 'DELETE_SCHOOL_SUCCESS';
export const DELETE_SCHOOL_FAILURE = 'DELETE_SCHOOL_FAILURE';
export const SET_SELECTED_SCHOOL = 'SET_SELECTED_SCHOOL';
export const CLEAR_SELECTED_SCHOOL = 'CLEAR_SELECTED_SCHOOL';
export const UPDATE_SCHOOL_FIELD = 'UPDATE_SCHOOL_FIELD';
export const RESET_SCHOOL_FORM = 'RESET_SCHOOL_FORM';
